import PowerCoachingQuiz from './power-coaching-quiz';
import AdminDashboard from './AdminDashboard';

// Simple path-based routing — no react-router needed
const path = window.location.pathname.replace(/\/$/, ""); // strip trailing slash

function App() {
  if (path === "/admin") {
    return <AdminDashboard />;
  }
  return <PowerCoachingQuiz />;
}

export default App;
